import React, { useState, useEffect } from 'react';
import styles from './UserManagement.module.css';

const UserEditModal = ({ open, user, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    role: '',
    status: '',
    avatar: ''
  });

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || '',
        email: user.email || '',
        role: user.role || '',
        status: user.status || '',
        avatar: user.avatar || ''
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  if (!open || !user) return null;

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Kullanıcı Düzenle</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="name">Ad Soyad</label>
            <input
              type="text"
              id="name"
              name="name"
              className={styles.input}
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="email">E-posta</label>
            <input
              type="email"
              id="email"
              name="email"
              className={styles.input}
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="role">Rol</label>
            <select
              id="role"
              name="role"
              className={styles.select}
              value={formData.role}
              onChange={handleChange}
              required
            >
              <option value="">Rol Seçin</option>
              <option value="admin">Admin</option>
              <option value="superuser">Super User</option>
              <option value="user">User</option>
            </select>
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="status">Durum</label>
            <select
              id="status"
              name="status"
              className={styles.select}
              value={formData.status}
              onChange={handleChange}
              required
            >
              <option value="">Durum Seçin</option>
              <option value="active">Aktif</option>
              <option value="inactive">Pasif</option>
            </select>
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="avatar">Profil Fotoğrafı (URL)</label>
            <input
              type="url"
              id="avatar"
              name="avatar"
              className={styles.input}
              value={formData.avatar}
              onChange={handleChange}
              placeholder="https://..."
            />
          </div>
          <div className={styles.modalActions}>
            <button
              type="button"
              className={`${styles.button} ${styles.secondaryButton}`}
              onClick={onClose}
            >
              İptal
            </button>
            <button
              type="submit"
              className={`${styles.button} ${styles.primaryButton}`}
            >
              Kaydet
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserEditModal; 